import { TextInput } from '@ardoq/forms';
import { FlexBox } from '@ardoq/layout';
import { Button } from '@ardoq/button';
import { AddIcon, Icon, IconName } from '@ardoq/icons';
import { type I18nLocale, t } from '@ardoq/i18n';
import { TableControlsInteractiveRow } from './TableControlsInteractiveRow';
import type { ReferenceInteractiveTopRowCommands } from './types';

type BrowseReferencesInteractiveRowProps = {
  commands: ReferenceInteractiveTopRowCommands;
  i18nLocale: I18nLocale;
};

export const BrowseReferencesInteractiveRow = ({
  commands,
  i18nLocale,
}: BrowseReferencesInteractiveRowProps) => {
  const searchReferencesLabel = t(
    i18nLocale,
    'inventory:search.searchReferences',
    'Search references'
  );
  return (
    <TableControlsInteractiveRow i18nLocale={i18nLocale}>
      <FlexBox gap="xsmall" align="center" flex={1}>
        <FlexBox gap="xsmall" align="center">
          <TextInput
            leftIconName={IconName.SEARCH}
            placeholder={searchReferencesLabel}
            aria-label={searchReferencesLabel}
          />
          <Button onClick={commands.openColumnSelectionPanel}>
            <Icon iconName={IconName.TABLE_COLUMNS} />
            {t(i18nLocale, 'inventory:search.columns', 'Columns')}
          </Button>
        </FlexBox>
      </FlexBox>

      <FlexBox gap="xsmall" align="center">
        <FlexBox gap="xsmall" align="center">
          <Button onClick={() => {}}>
            <AddIcon />
            {t(i18nLocale, 'inventory:interactiveRow.create', 'Create')}
          </Button>
        </FlexBox>
      </FlexBox>
    </TableControlsInteractiveRow>
  );
};
